var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"white--text",style:(_vm.styles.msgTimestampStyle)},[_vm._v(" "+_vm._s(_vm.messageTime)+" "),_c('i',{staticClass:"message__timestamp__img straight_color",style:(_vm.styles.iconStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }